import React, { useState, useEffect } from 'react'
import { useParams, Link, useNavigate } from 'react-router'

// evertel
import {  Button, Card, CardBody, Col,
    Row, useUI, PasswordInput, Logo } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { Analytics } from '@evertel/analytics'
import { LoginService } from '@evertel/session/LoginService'

const ResetPassword: React.FC = () => {

    const analytics = useService(Analytics)
    const loginService = useService(LoginService)

    // Authentication related state
    const [token, setToken] = useState<string | null>(null)
    const [passwordHasBeenReset, setPasswordHasBeenReset] = useState(false)

    const { addToast } = useUI()

    const navigate = useNavigate()

    // Split password state into individual hooks
    const [newPassword, setNewPassword] = useState('')
    const [isPasswordValid, setIsPasswordValid] = useState(false)

    // UI feedback state
    const [alert, setAlert] = useState({
        text: '',
        color: 'danger' as 'danger' | 'success'
    })

    // Loading state
    const [isLoading, setIsLoading] = useState(false)

    const { token: urlToken } = useParams<{ token: string }>()

    useEffect(() => {
        if (!urlToken) {
            setAlert({
                text: 'Unable to retrieve password reset token. Please click on your reset link to try again.',
                color: 'danger'
            })
        } else {
            setToken(urlToken)
        }

        analytics.logView('/reset-password')
    }, [urlToken])

    const resetPassword = async (e) => {
        e.preventDefault()
        setAlert({ text: '', color: 'danger' })

        if (!newPassword) {
            addToast({
                color: 'danger',
                title: 'Error',
                message: 'Please enter a password.'
            })
            return
        }

        if (!token) {
            addToast({
                color: 'danger',
                title: 'Error',
                message: 'Invalid reset token.'
            })
            return
        }

        try {
            setIsLoading(true)

            const passwordTrim = newPassword.trim()

            await loginService.resetPassword(passwordTrim, passwordTrim, token)

            setAlert({
                text: 'Your password has been reset. Returning to login',
                color: 'success'
            })
            setPasswordHasBeenReset(true)


        } catch (error: any) {
            setAlert({
                text: error.message || error,
                color: 'danger'
            })
            addToast({
                color: 'danger',
                title: 'Oops',
                message: error.message || error
            })
        } finally {
            setIsLoading(false)

        }

    }

    return (
        <div className="app auth-layout fadeIn animated bg-img" style={{ height: '100vh', overflow: 'auto' }}>
            <Row align="center" valign="center" className="d-flex p-4 h-100">
                <Card className="p-4" style={{minHeight: 370, maxWidth: 600}}>
                    <CardBody className="">
                        <form onSubmit={resetPassword}>
                            <fieldset disabled={passwordHasBeenReset}>
                                <div className="text-center mb-5">
                                    <Logo className="mb-4" />
                                    <h1>Reset your password</h1>
                                </div>
                                {/* {alert.text && <InfoBox color={alert.color}>{alert.text}</InfoBox>} */}
                                <PasswordInput
                                    value={newPassword}
                                    label="New Password"
                                    onChange={setNewPassword}
                                    onValidate={setIsPasswordValid}
                                    disabled={passwordHasBeenReset}
                                    placeholder="Password"
                                    enablePasswordValidation
                                />

                                {!passwordHasBeenReset &&
                                <Col className="mt-4">
                                    <Button
                                        color="primary"
                                        loading={isLoading}
                                        disabled={!isPasswordValid}
                                        type="submit">
                                        Reset
                                    </Button>
                                </Col>
                                }
                            </fieldset>
                            <Col className="mt-4">
                                <Button
                                    color="link"
                                    onClick={() => navigate('/login')}
                                >
                                    Return to Login
                                </Button>
                            </Col>

                        </form>
                    </CardBody>
                </Card>
            </Row>
        </div>
    )
}

export { ResetPassword }
